<div class="snack-container" [attr.data-severity]="data.severity">

  <mat-icon class="snack-icon">{{ icon }}</mat-icon>

  <div class="snack-content">
    <span class="snack-title">{{ data.title }}</span>

    @if (data.message) {
      <span class="snack-message">{{ data.message }}</span>
    }

    @if (data.entries?.length) {
      <ul class="snack-entries">
        @for (entry of data.entries; track entry) {
          <li>{{ entry }}</li>
        }
      </ul>
    }
  </div>

  <button mat-icon-button class="snack-dismiss" (click)="dismiss()" aria-label="Schließen">
    <mat-icon>close</mat-icon>
  </button>

</div>

